<hc-modal>
    <hc-modal-header
        ><div class="icon-left icon-databricks header-icon"></div>
        Databricks Login Required</hc-modal-header
    >
    <hc-modal-body>
        <div class="modal-wrapper">
            <div class="main-icon-container">
                <span class="icon-databricks"></span>
            </div>
            <div>
                Please sign in to Databricks to continue.
                <div class="dbx-login-launch-button">
                    <button hc-button buttonStyle="primary-alt" (click)="dbxLogIn()">
                        Sign in to Databricks<span class="icon-right icon-external-link launch-icon"></span>
                    </button>
                </div>
                <div class="upper-border"></div>
                <div>Once you've signed in, return to this window and <strong>click continue</strong>.</div>
            </div>
        </div>
    </hc-modal-body>
    <hc-modal-footer>
        <div>
            <button hc-button buttonStyle="link" class="cancel-button" (click)="cancel()">Cancel</button>
        </div>
        <div>
            <button hc-button buttonStyle="primary" (click)="navigateToDashboard()" [disabled]="!loginClick">
                Continue
            </button>
        </div>
    </hc-modal-footer>
</hc-modal>
